"use client"

import { css, fmobile, fresponsive, styled } from "library/styled"
import AdvantageDesktopTablet from "./DesktopTablet"
import AdvantageMobile from "./Mobile"

export type AccordionData = {
	key: string
	title: string
	content: string
	colors: {
		primary: string
		secondary: string
		icon: string
	}
	logo: React.ReactNode
	image: React.ReactNode
}

export default function Advantage() {
	return (
		<>
			<NotMobile>
				<AdvantageDesktopTablet />
			</NotMobile>
			<Mobile>
				<AdvantageMobile />
			</Mobile>
		</>
	)
}

const NotMobile = styled("div", {
	...fresponsive(css`
		display: block;
	`),
	...fmobile(css`
		display: none;
	`),
})

const Mobile = styled("div", {
	...fresponsive(css`
		display: none;
	`),

	...fmobile(css`
		display: block;
	`),
})
